import { MapTo } from '@adobe/aem-react-editable-components';
import CapitalRatiosChart, { CapitalRatiosChartEditConfig } from './CapitalRatiosChart';

export default MapTo('cob-corp-acquisition/components/creditonebank/capital-ratios-chart')(CapitalRatiosChart, CapitalRatiosChartEditConfig);